import moment from "moment"
import { useEffect, useState } from "react"
import TitleCard from "../../../daisyUI/components/Cards/TitleCardTs"

import SearchBar from "../../../daisyUI/components/Input/SearchBar"
import { useUserFetch } from "../../../hooks/fetch/useUserFetch"
import {  UserRequestedMortgage, UserRequestedWarranty } from "../../../interfaces/user"
import { Link } from "react-router-dom"
import Pagination from "../../../components/ui/pagination/Pagination"
import "./UserActivities.scss"
import Lottie from "lottie-react";
import loaderIris from "../../../lotties/orange-loader.json";


const TopSideButtons = ({ applySearch, className }:
    { applySearch: any, className?: string }) => {

    const [searchText, setSearchText] = useState("")

    useEffect(() => {
        applySearch(searchText)
    }, [searchText])

    return (
        <div className={"tw-inline-block tw-float-right " + className}>
            <SearchBar searchText={searchText} styleClass="tw-mr-4" setSearchText={setSearchText} placeholderText={'Buscar cliente'} />
        </div>
    )
}


function UserRequestedMortgages() {

    const MAX_PAGES = 3
    const LIMIT = 10
    const INITIAL_PAGE = 1
    const { getOffers, getRequestedMortgages } = useUserFetch()
    const [warranties, setWarranties] = useState<UserRequestedMortgage[]>([])
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(INITIAL_PAGE)
    const [totalPages, setTotalPages] = useState<number>()
    const [searchTerm, setSearchTerm] = useState('')
    const [showTableBody, setShowTableBody] = useState(false)
    const [hasSome , setHasSome] = useState(false)

    useEffect(() => {
        setLoading(true)
        loadVisits(true,'', LIMIT, INITIAL_PAGE)
        
    }, [])

    useEffect(() => {
        setShowTableBody(warranties.length > 0 ? true : false)
    }, [warranties,searchTerm])

    const loadVisits = async (firstLoad : boolean ,search?: string, loadLimit?: number, page?: number) => {

        return getRequestedMortgages(search, loadLimit, page).then(response => {
            setLoading(false)
            if (response.success) {
                setWarranties(response.data)
                if (!loadLimit) loadLimit = LIMIT
                let total_pages = Math.ceil(response.total / loadLimit)
                setTotalPages(total_pages)

                if(response.data.length > 0 && firstLoad) setHasSome(true)
                
            } else {
                setWarranties([])
                setTotalPages(0)
            }
            return true
        }).catch(err => {
            console.error(err)
            setLoading(false)
        })
    }


    // Search according to name
    const applySearch = (value: any) => {
        setSearchTerm(value)
        loadVisits(false,value, LIMIT, INITIAL_PAGE)
    }

    const handlePagination = (pageNav: number) => {
        if (pageNav != currentPage) {
            setCurrentPage(pageNav)
            loadVisits(false,'', LIMIT, pageNav)
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

    }


    return (
        <>
            <div className={`user-activities user-requested-mortgages ${(!warranties || warranties.length == 0) && !loading ? 'empty' : ''}`}>
                <TitleCard title={'Préstamos Hipotecarios Derivados'} topMargin="tw-pt-4 tw-border "
                    TopSideButtons={ <TopSideButtons applySearch={applySearch} className={loading || !hasSome  ? ' tw-hidden ' : ''} /> }>


                    <div className="tw-overflow-x-auto tw-w-full tw-mt-6">
                        {/* Loader */}
                        {
                            loading && <main className="user-guarantees main container p-3 p-sm-5">
                                <div style={{ height: 400 }} className="w-100 d-flex align-items-center justify-content-center">
                                    <Lottie animationData={loaderIris} style={{ height: 100 }} loop /></div>
                            </main>
                        }

                        {/* Table */}
                        {
                            !loading &&
                            <>
                                <table className="tw-table tw-w-full responsive-table ">
                                    <thead>
                                        <tr>
                                            <th>Cliente</th>
                                            <th>Email</th>
                                            <th>Teléfono</th>
                                            <th>Documento</th>
                                            <th>Solicitud Enviada</th>
                                        </tr>
                                    </thead>
                                    {
                                        showTableBody ?
                                            <tbody>
                                                {
                                                    warranties.map((o, k) => {
                                                        return (
                                                            <tr key={k}>
                                                                <td>
                                                                    <span className="mobile-title">Cliente: </span> <p>{o.client_name}</p>
                                                                </td>
                                                                <td>
                                                                    <span className="mobile-title">Email: </span> <p>{o.client_email}</p>
                                                                </td>
                                                                <td>
                                                                    <span className="mobile-title">Teléfono: </span> <p>{o.client_phone}</p>
                                                                </td>
                                                                <td>
                                                                    <span className="mobile-title">Documento: </span> <p>{o.client_document}</p>
                                                                </td>
                                                                <td><span className="mobile-title">Fecha: </span> {moment(o.created_at).format("D/M/yyyy")}</td>
                                                                
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody> : ''
                                    }

                                </table>

                                {showTableBody && totalPages && <Pagination currentPage={currentPage} handlePagination={handlePagination} totalPages={totalPages} maxPages={MAX_PAGES} />}
                            </>
                        }


                        {/* Message */}
                        {
                            (!warranties || warranties.length == 0) && !loading &&
                            <p className="text-center mt-4">{searchTerm == '' || !searchTerm ? 'Aún no existen préstamos derivados' :
                                'No se encontró ningún registro que coincida'}
                            </p>
                        }

                    </div>

                </TitleCard>
            </div>


        </>
    )
}


export default UserRequestedMortgages